import { convertToUUID } from './convertToUUID';
import { isProbablyUUID } from './isProbablyUUID';

export const safeConvertToUUID = (id: string | any) => {
  return isProbablyUUID(id) ? convertToUUID(id) : id;
};
